import { render, staticRenderFns } from "./PasswordResetMailInputPage.vue?vue&type=template&id=a75fd674&scoped=true"
import script from "./PasswordResetMailInputPage.vue?vue&type=script&lang=ts"
export * from "./PasswordResetMailInputPage.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetMailInputPage.vue?vue&type=style&index=0&id=a75fd674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75fd674",
  null
  
)

export default component.exports